import React, {useState} from 'react';

import {
  Container,
  Content,
  FilterList,
  Filter,
  FilterText,
  Icon,
  FilterInfo,
  ContentHeader,
  FormFooter,
  Form,
} from './styles';
import {Header} from '../../../../../components/Interface/Headers/Header';
import {useNavigation, useRoute} from '@react-navigation/native';

import {Titles} from '../../../../../components/Interface/Typographies/Titles';

import {parceiroCategorias} from '../../../../../dtos/ParceiroDTO';
import {RFValue} from 'react-native-responsive-fontsize';

import {LinkButton} from '../../../../../components/Interface/Forms/Buttons/LinkButton';
import {SearchInput} from '../../../../../components/Interface/Forms/Inputs/SearchInput';
import {NotFound} from '../../../../../components/Interface/Search/NotFound';
import {Keyboard, TouchableWithoutFeedback} from 'react-native';

interface Params {
  categoria: string;
}

export function StoreFiltersCategory() {
  const navigation = useNavigation();
  const route = useRoute();

  const [search, setSearch] = useState('');

  const [filteredCategories, setFilteredCategories] = useState<string[]>(
    [] as string[],
  );

  const {categoria} = route.params as Params;

  const selectedCategoria = categoria;

  function handleNavigate(categoria: any) {
    navigation.navigate({
      name: 'StoreSearchFilters',
      params: {categoria},
      merge: true,
    });
  }

  function handleSearchCategories(name: string) {
    const filter = parceiroCategorias.filter(e =>
      e
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(
          name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, ''),
        ),
    );

    setFilteredCategories(filter);
    setSearch(name);
  }

  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <Container>
        <Header icon="chevron-left" action={() => navigation.goBack()} />

        <Content>
          <ContentHeader>
            <Titles title="Categoria" />
          </ContentHeader>

          <Form>
            <SearchInput
              placeholder="Buscar categoria"
              value={search}
              autoCapitalize="sentences"
              onChangeText={text => handleSearchCategories(text)}
            />
            <FormFooter>
              <LinkButton
                text="Limpar filtro"
                enabled
                action={() => handleNavigate(undefined)}
              />
            </FormFooter>
          </Form>

          <FilterList
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              paddingBottom: RFValue(20),
            }}>
            {search.length !== 0 ? (
              filteredCategories.length !== 0 ? (
                filteredCategories.map((categoria, index) => (
                  <Filter
                    style={{
                      borderBottomWidth:
                        index === filteredCategories.length - 1 &&
                        filteredCategories.length > 1
                          ? 0
                          : 1,
                    }}
                    activeOpacity={1}
                    onPress={() => handleNavigate(categoria)}
                    key={categoria}>
                    <FilterInfo>
                      <FilterText active={categoria === selectedCategoria}>
                        {categoria}
                      </FilterText>
                    </FilterInfo>
                    <Icon
                      name={
                        categoria === selectedCategoria
                          ? 'check'
                          : 'chevron-right'
                      }
                    />
                  </Filter>
                ))
              ) : (
                <NotFound />
              )
            ) : (
              parceiroCategorias.map((categoria, index) => (
                <Filter
                  style={{
                    borderBottomWidth:
                      index === parceiroCategorias.length - 1 &&
                      parceiroCategorias.length > 1
                        ? 0
                        : 1,
                  }}
                  activeOpacity={1}
                  onPress={() => handleNavigate(categoria)}
                  key={categoria}>
                  <FilterInfo>
                    <FilterText active={categoria === selectedCategoria}>
                      {categoria}
                    </FilterText>
                  </FilterInfo>
                  <Icon
                    name={
                      categoria === selectedCategoria
                        ? 'check'
                        : 'chevron-right'
                    }
                  />
                </Filter>
              ))
            )}
          </FilterList>
        </Content>
      </Container>
    </TouchableWithoutFeedback>
  );
}
